import { DownWhiteIcon } from "../ui/down-red-icon";
import { QuantityGemsComponent } from "../ui/quantity-gems.component";
import { UpWhiteIcon } from "../ui/up-green-icon";

interface GameControlsProps {
  isPlaying: boolean,
  price: number,
  startGame: (isTradingUp: boolean) => void,
  endGame: () => void,
  extendGame: () => void
}

const GameControls: React.FC<GameControlsProps> = ({ isPlaying, price, startGame , endGame, extendGame}) => {

  return (
    <div className="w-full flex flex-col flat-card !pt-3">

      {
        !isPlaying && <>

          <p className="text-xl text-center mb-4 font-BioRhyme">
            Ready to <span className="bg-orange px-1 mr-1 text-white rounded-md">Trade</span>?
          </p>

          <div className="w-full flex justify-evenly">

            <button onClick={() => startGame(false)} className="flat-button bg-red-500 rounded-md medium-icon-left uppercase px-4 h-11 w-[128px]">
              <DownWhiteIcon h={16} />
              <span>down</span>
            </button>

            <button onClick={() => startGame(true)} className="flat-button bg-victory-green rounded-md medium-icon-left uppercase px-4 h-11 w-[128px]">
              <UpWhiteIcon h={16} />
              <span>up</span>
            </button>

          </div>

        </>
      }

      {isPlaying && <>

        <p className="text-xl text-center mb-4 font-BioRhyme">
          Good timing is key...
        </p>

        <div className="w-full flex justify-evenly">

          <button onClick={() => extendGame()} className="flat-button bg-blue rounded-md medium-icon-left uppercase h-11 w-[128px]">
            <span className="grow text-cente">+10 sec</span>
            <span className="bg-blue-700 px-1 rounded-md mr-1">
              <QuantityGemsComponent quantity={price} size={12} />
            </span>
          </button>

          <button onClick={() => endGame()} className="flat-button bg-blue rounded-md medium-icon-left uppercase px-4 h-11 w-[128px]">
            <span>Close</span>
          </button>

        </div>

      </>
      }

    </div>
   );
}

export default GameControls;

// box - shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px - 3px, rgba(0, 0, 0, 0.2) 0px - 3px 0px inset;